import { Paper, Stack, Typography } from '@mui/material';

const MetricCard = ({ title, value, accent = 'blue', formatNumber }) => (
  <Paper
    sx={{
      p: { xs: 2.25, md: 3 },
      borderRadius: 1,
      border: '1px solid rgba(148, 163, 184, 0.14)',
      boxShadow: '0px 20px 40px rgba(15, 23, 42, 0.05)',
      background:
        accent === 'blue'
          ? 'linear-gradient(180deg, rgba(12, 83, 183, 0.08), rgba(255,255,255,0.96))'
          : 'linear-gradient(180deg, rgba(0, 167, 111, 0.08), rgba(255,255,255,0.96))'
    }}
  >
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: '-0.03em' }}>
        {formatNumber(value)}
      </Typography>
    </Stack>
  </Paper>
);

export default MetricCard;
